module.exports = __webpack_public_path__ + "img/stickies-fill.7116b9bd.svg";